export default {
  computed: {
    hint: {
      get() { return this.$store.getters('textreplacement/hint') },
      set(val) { return this.$store.commit('textreplacement/setHint', val) }
    },
    matched_replacement: {
      get () { return this.$store.getters["textreplacement/matched_replacement"]; },
      set (val) { return this.$store.commit("textreplacement/setMatchedReplacement", val); },
    }
  },
  data() {
    return {
      count: 0
    }
  },
  methods: {
    setHint (val, click) {
      this.hint = val;
      this.$root.textReplacementOnClick = click;
    },
    getReplacement (reason) {
      if (this.matched_replacement != '') {
        let lines = reason.split('\n');
        let last_line = lines.pop();
        let arr = last_line.split(' ');

        let message = '';
        let full_text = '';

        arr.pop();

        if (lines.length > 0) {
          full_text = `${lines.join('\n')}\n`;
        }

        if (arr.length > 0) {
          message = `${full_text}${arr.join(' ')} ${this.matched_replacement}`;
        } else {
          message = `${full_text}${this.matched_replacement}`;
        }
        
        this.hint = '';
        return message;
      } 
      return false;
    },
    clearReplacement () {
      this.matched_replacement = '';
    },
    triggerSelection (reason) {
      let text = this.getReplacement(reason);
      if (this.$root.textReplacementOnClick != null && text != false) {
        this.$root.textReplacementOnClick(text);
      }
    }
  }
}